import { Box, Stack, Typography } from '@mui/material'
import { observer } from 'mobx-react-lite'
import StarIcon from '@mui/icons-material/Star'

const CenturionProgressBar = observer(({ value = 0, markers = [30, 60, 100], min = 0, max = 100 }) => {
    const percentage = Math.min(Math.max(((value - min) / (max - min)) * 100, 0), 100)
    const ticks = [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]
    const hundredPercentValue = value > 100 ? 100 : value

    return (
        <Stack sx={{ width: '100%', position: 'relative', paddingTop: '30px', paddingBottom: '10px' }}>
            {/* Value Bubble */}
            <Box
                sx={{
                    position: 'absolute',
                    left: `${percentage}%`,
                    top: '-8px',
                    transform: 'translateX(-50%)',
                    zIndex: 2
                }}>
                <Box
                    sx={{
                        backgroundColor: 'rgba(255, 231, 172, 1)',
                        borderRadius: '20px',
                        padding: '0px 16px',
                        paddingTop: '0px',
                        position: 'relative',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            left: '50%',
                            top: '26px',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '8px solid transparent',
                            borderRight: '8px solid transparent',
                            borderTop: '5px solid rgba(138, 155, 176, 1)'
                        }
                    }}>
                    <Typography
                        sx={{
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            fontWeight: 400,
                            color: '#003B6F'
                        }}>
                        {hundredPercentValue}
                    </Typography>
                </Box>
            </Box>

            {/* Progress Bar Container */}
            <Box
                sx={{
                    width: '100%',
                    height: '16px',
                    backgroundColor: '#E8ECF0',
                    borderRadius: '10px',
                    position: 'relative',
                    overflow: 'hidden'
                }}>
                {/* Progress Fill */}
                <Box
                    sx={{
                        width: `${percentage}%`,
                        height: '100%',
                        background: 'rgba(183, 226, 80, 1)',
                        borderRadius: '10px',
                        transition: 'width 0.3s ease',
                        borderTopRightRadius: '0px',
                        borderBottomRightRadius: '0px'
                    }}
                />
            </Box>

            {/* Ticks Line with Stars and Numbers */}
            <Box sx={{ position: 'relative', width: '100%', marginTop: '8px', height: '40px' }}>
                {/* Horizontal Line */}
                <Box
                    sx={{
                        position: 'absolute',
                        top: '8px',
                        left: 0,
                        right: 0,
                        height: '1px',
                        backgroundColor: '#D0D7DE'
                    }}
                />

                {/* Ticks and Labels */}
                {ticks.map(tick => {
                    const tickPos = ((tick - min) / (max - min)) * 100
                    const isMarker = markers.includes(tick)
                    return (
                        <Box
                            key={tick}
                            sx={{
                                position: 'absolute',
                                left: `${tickPos}%`,
                                transform: 'translateX(-50%)',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                top: isMarker ? '4px' : '0px'
                            }}>
                            {/* Star or Tick */}
                            {isMarker ? (
                                <StarIcon
                                    sx={{
                                        fontSize: '16px',
                                        color: '#F5A623',
                                        marginTop: '3px'
                                    }}
                                />
                            ) : (
                                <Box
                                    sx={{
                                        width: '1px',
                                        height: '8px',
                                        backgroundColor: '#D0D7DE',
                                        marginTop: '8px'
                                    }}
                                />
                            )}

                            {/* Number Label */}
                            <Typography
                                sx={{
                                    fontFamily: 'Inter',
                                    fontSize: '12px',
                                    fontWeight: isMarker ? 700 : 400,
                                    color: isMarker ? '#003B6F' : '#9EA9B9',
                                    marginTop: isMarker ? '-2px' : '4px'
                                }}>
                                {tick}
                            </Typography>
                        </Box>
                    )
                })}
            </Box>
        </Stack>
    )
})

export default CenturionProgressBar
